module.exports = __webpack_public_path__ + "static/media/laputa-loc.cc524930.JPG";